import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {

  // MULTIPLE LAYOUT
  const swiperEl = document.querySelector('.testimonialsSwiper');
  const items = document.querySelectorAll('.testimonialsSwiper .swiper-slide').length;

  if (swiperEl) {
    new Swiper(swiperEl, {
      modules: [Navigation],
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: { slidesPerView: 1 },
        768: { slidesPerView: items < 3 ? items : 3 },
        1024: { slidesPerView: items < 3 ? items : 3 },
      },
    });
  }

  // SINGLE LAYOUT
  const swiperElSingle = document.querySelector('.testimonialsSwiperSingle');

  if (swiperElSingle) {
    new Swiper(swiperElSingle, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "progressbar"   // ← LINE PAGINATION
      },
      navigation: {
        nextEl: ".swiper-button-next-single",
        prevEl: ".swiper-button-prev-single",
      }
    });
  }


  // Steps Swiper
  const swiperElSteps = document.querySelector('.stepsSwiper');
    new Swiper(swiperElSteps, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      pagination: {
          el: ".progress-pagination",
          type: "progressbar",
          enabled: true,
      },
      navigation: {
          nextEl: ".swiper-button-next-step",
          prevEl: ".swiper-button-prev-step",
      }
  });



  // Accordions
  // Select by class (your template uses class="faq-accordion")
  const accordions = document.querySelectorAll('.faq-accordion');
  if (!accordions.length) return;

  accordions.forEach(container => {
    const triggers = container.querySelectorAll('button[aria-controls]');
    if (!triggers.length) return;

    function closePanel(trigger) {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = container.querySelector('#' + panelId);

      trigger.setAttribute('aria-expanded', 'false');

      if (panel) {
        // collapse
        panel.style.maxHeight = '0px';
        panel.style.opacity = '0';
      }

      const iconWrap = trigger.querySelector('[data-open]');
      if (iconWrap) {
        iconWrap.setAttribute('data-open', 'false');
        iconWrap.querySelector('.plus-icon')?.classList.remove('hidden');
        iconWrap.querySelector('.minus-icon')?.classList.add('hidden');
      }
    }

    function openPanel(trigger) {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = container.querySelector('#' + panelId);

      trigger.setAttribute('aria-expanded', 'true');

      if (panel) {
        // expand to its scrollHeight so CSS transition animates
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.style.opacity = '1';
      }

      const iconWrap = trigger.querySelector('[data-open]');
      if (iconWrap) {
        iconWrap.setAttribute('data-open', 'true');
        iconWrap.querySelector('.plus-icon')?.classList.add('hidden');
        iconWrap.querySelector('.minus-icon')?.classList.remove('hidden');
      }
    }

    // Attach click handlers for this accordion only
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // close all inside this accordion
        triggers.forEach(t => closePanel(t));

        // if it wasn't expanded before, open it now
        if (!isExpanded) openPanel(trigger);
      });
    });

    // Optional: ensure panels are correctly collapsed on load (in case of inline styles)
    triggers.forEach(t => {
      const panelId = t.getAttribute('aria-controls');
      const panel = container.querySelector('#' + panelId);
      if (panel) {
        // make sure initial style matches aria-expanded
        if (t.getAttribute('aria-expanded') === 'true') {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.style.opacity = '1';
          t.querySelector('[data-open]')?.setAttribute('data-open', 'true');
        } else {
          panel.style.maxHeight = '0px';
          panel.style.opacity = '0';
          t.querySelector('[data-open]')?.setAttribute('data-open', 'false');
        }
      }
    });
  });


});
